const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * LANDING PAGE EVENTS                                                        *
 * - Birthday landing date saved                                              *
 * - Birthday landing item clicked                                            *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.birthdayLandingDateSaved,
    () => {
      pushEvent(
        createCustomEventGA4('landing_birthday', [
          ['action', 'guardar'],
        ])
      );
    }
  );

  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.birthdayLandingItemClicked,
    (item) => {
      pushEvent(
        createCustomEventGA4('birthday', [
          ['action', 'click'],
          ['item', item],
        ])
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
